import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import auth from "./auth";
import cities from "./cities";
import docks from "./docks";
import locks from "./locks";
import notifications from "./notifications";
import payment from "./payment";
import rentals from "./rentals";
import rewards from "./rewards";
import screen from "./screen";
import stations from "./stations";
import users from "./users";
import vehicle from "./vehicle";

const authPersistConfig = {
  key: "auth",
  storage,
  timeout: null,
  blacklist: ["adminDetails"],
};

const citiesPersistConfig = {
  key: "cities",
  storage,
  timeout: null,
  blacklist: [
    "downloadedCoupon",
    "downloadCouponSuccess",
    "cityWhitelabelMapping",
    "getCityWhitelabelMappingSuccess",
  ],
};

const stationsPersistConfig = {
  key: "stations",
  storage,
  timeout: null,
};

const usersPersistConfig = {
  key: "users",
  storage,
  timeout: null,
  blacklist: ["internalUserCreateSuccess"],
};

const screenPersistConfig = {
  key: "screen",
  storage,
  timeout: null,
  blacklist: [
    "order",
    "orderBy",
    "filterValue",
    "searchValue",
    "currentPageValue",
    "currentMenu",
    "passedParams",
  ],
};

const vehiclePersistConfig = {
  key: "vehicle",
  storage,
  timeout: null,
  blacklist: [
    "getVehicleSuccess",
    "getBikeByIdSuccess",
    "getBikeStatusSuccess",
    "getLockStatusesSuccess",
    "getBrandsSuccess",
    "updateBikeSuccess",
    "bikes",
    "bike",
    "bikesResult",
    "brands",
    "lockStatuses",
    "hasMoreBikeHistory",
  ],
};

export default combineReducers({
  auth: persistReducer(authPersistConfig, auth),
  screen: persistReducer(screenPersistConfig, screen),
  users: persistReducer(usersPersistConfig, users),
  stations: persistReducer(stationsPersistConfig, stations),
  payment,
  vehicle: persistReducer(vehiclePersistConfig, vehicle),
  locks,
  docks,
  rentals,
  cities: persistReducer(citiesPersistConfig, cities),
  notifications,
  rewards,
});
